
export default {
  institutions:[],
  accountbank:[],
  bank:[],
  downloadinvoices:[],
  efacturastobesent:[],
  downloadinvoicestreated:[],
  transportlist:[],
  operationlist:[],
  productlist:[]
}
